import { render, staticRenderFns } from "./LugarInteresModalEdicion.vue?vue&type=template&id=6494f059&scoped=true&"
import script from "./LugarInteresModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./LugarInteresModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./LugarInteresModalEdicion.vue?vue&type=style&index=0&id=6494f059&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6494f059",
  null
  
)

export default component.exports